import { Injectable } from '@angular/core';

import { ToastController, ToastOptions } from '@ionic/angular/standalone';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    /* eslint-disable */
    currentToast: any = null;

    toastStyles = {
        default: 'secondary',
        success: 'success',
        error: 'danger'
    };

    constructor(private toastCtrl: ToastController) {}

    successToast(options: ToastOptions) {
        this.presentNotice(options, 'success');
    }

    errorToast(options: ToastOptions) {
        this.presentNotice(options, 'error');
    }

    async presentNotice(options: ToastOptions, type: 'default' | 'success' | 'error' = 'default') {
        const toastOptions = {
            message: options.message || '',
            duration: options.duration || 2000,
            position: options.position || 'top',
            color: options.color || this.toastStyles[type]
        };

        this.currentToast = await this.toastCtrl.create({
            message: toastOptions.message,
            duration: toastOptions.duration,
            position: toastOptions.position,
            color: toastOptions.color,
            cssClass: 'toast',
            swipeGesture: 'vertical'
        });
        this.currentToast.present();
    }

    async persistentNotice(options: ToastOptions, type: 'default' | 'success' | 'error' = 'default') {
        const toastOptions = {
            message: options.message || '',
            position: options.position || 'bottom',
            color: options.color || this.toastStyles[type]
        };

        this.currentToast = await this.toastCtrl.create({
            message: toastOptions.message,
            position: toastOptions.position,
            color: toastOptions.color,
            cssClass: 'toast'
        });
        this.currentToast.present();
    }

    persistentNoticeDismiss() {
        if (this.currentToast) {
            this.toastCtrl.dismiss();
            this.currentToast = null;
        }
    }
}
